import { getIsZeroFeesActiveForMarket } from 'src/utils/zeroFees';
import PresetTag from 'src/components/Tags/PresetTag';

interface Props {
	marketIndex: number;
	isPerp: boolean;
	className?: string;
}

/**
 * Auto displays / hides the `zero-fees` variant tag based on enabled status.
 */
export default function ZeroFeesTag({ marketIndex, isPerp, className }: Props) {
	const isZeroFeesActive = getIsZeroFeesActiveForMarket({
		marketIndex,
		isPerp,
	});

	if (!isZeroFeesActive) {
		return null;
	}

	return <PresetTag preset="zero-fees" className={className} />;
}
